module.exports = __webpack_public_path__ + "img/ring_g_i_1_0.49f48e99.png";